import { Link, useLocation } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';

const STORE_TABS = [
  { label: 'MW Store', to: '/disneyland/mystore' },
  { label: 'Recharge Credits', to: '/disneyland/recharge' },
  { label: 'My Collection', to: '/disneyland/mycollection' },
  { label: 'My Trade Request', to: '/disneyland/mytrade-request' },
  { label: 'My History', to: '/disneyland/myhistory' },
  { label: 'Gift Credits', to: '/disneyland/giftcredits' },
];

export const StoreTabs = () => {
  const { pathname } = useLocation();

  return (
    <ul className='react-tabs__tab-list' role='tablist'>
      {STORE_TABS.map((tab) => {
        const isSelected = pathname === tab.to;

        return (
          <li
            aria-selected={isSelected}
            className={`react-tabs__tab${isSelected ? ' react-tabs__tab--selected' : ''}`}
            key={tab.to}
            role='tab'
          >
            <Link to={tab.to}>{tab.label}</Link>
          </li>
        );
      })}
    </ul>
  );
};
